import { IAssignmentState } from './IAssignmentState';

export const initialState: IAssignmentState = {
  currentAssignmentQuestions: null,
};
